import React, { useEffect, useState, memo } from 'react';
import { WaterfallChart } from '@components/charts';
import { useSelector } from 'react-redux';
import ValueDriversGrid from './valueDriversGrid';
import Dropdown, { VALUE_DRIVER } from '../insightsDropdown';
import { API } from '@service';
import Loading from '@components/loading';
import { generateProjectUrlSearch } from '@utils/common';
// import PowerBiLink from '@modules/analysis/detail/subsidiaries/powerbiEmbed';
// import SectionComment from '@components/CommentCenter/SectionComment';
// import CommentAnchor from '@components/directUser/CommentAnchor';

import SectionComment from 'src/ddvComment/SectionComment';
import CommentAnchor from 'src/ddvComment/directUser/CommentAnchor';
import { projectRole } from '@model';
import ConcurrentEditButton from '@components/concurrentEditButton';

const getAlertText = (email) =>
  `Value Drivers are currently locked for editing by ${email}.`;

const ValueDriver = (props) => {
  const projectId = useSelector((state) => state.common.currentId);
  const projectPermission = useSelector(
    (state) => state.common.projectCompanyInfo?.currentUserPermission,
  );

  const [isLoading, setIsLoading] = useState(false);
  const [chartData, setChartData] = useState({ dataList: [] });
  const [chartHidden, setChartHidden] = useState(false);
  const [gridData, setGridData] = useState([]);
  const [mode, setMode] = useState('scale');
  const [format, setFormat] = useState('USD');
  const isInternal = JSON.parse(
    window.localStorage.userInfo || '{}',
  )?.isInternal;
  const isClient =
    JSON.parse(window.localStorage.userInfo || '{}')?.isClient ||
    projectPermission === projectRole['View-Only'];
  const getChartAndGridData = async () => {
    if (!projectId) {
      return;
    }
    setIsLoading(true);
    const [cData, gData] = await Promise.all([
      API.getWaterfallChartData(projectId),
      API.getValueDriversGrid(projectId),
    ]);
    setChartData(cData);
    setGridData(gData?.valueDriverItems || []);
    setMode(gData.mode);
    setFormat(gData.format);
    setIsLoading(false);
  };

  useEffect(() => {
    getChartAndGridData();
  }, [projectId]);

  return (
    <div className="insights-container value-drivers-view-container">
      <Dropdown section={VALUE_DRIVER} />
      <div className="value-driver-view-header">
        <SectionComment
          module={props.currentSubmoduleName}
          placement="bottomRight"
          className={`value-drivers-comment${isClient ? ' client-view' : ''}`}
        />
        {isInternal && (
          <ConcurrentEditButton
            identifier="value-driver"
            handleRefresh={getChartAndGridData}
            updateTimeFieldName="valueDriverLastUpdateTime"
            autoRefresh
            getAlertText={getAlertText}
            buttonProps={{
              className: 'role-control',
              size: 'lg',
              children: 'Manage Value Drivers',
              onClick: () => {
                props.history.push(
                  `/insights/manager?${generateProjectUrlSearch(projectId)}`,
                  {
                    fromView: true,
                  },
                );
              },
            }}
          />
        )}
        {/*{isInternal && (*/}
        {/*  <PowerBiLink*/}
        {/*    text="Access Synergy Estimator"*/}
        {/*    url="/powerBIReport/getSynergyEstimatorReport"*/}
        {/*  />*/}
        {/*)}*/}
      </div>

      {isLoading ? (
        <Loading style={{ textAlign: 'center', paddingTop: '6.25rem' }} />
      ) : (
        <>
          <WaterfallChart
            dataSrc={chartData}
            isHidden={chartHidden}
            setIsHidden={setChartHidden}
          />
          <ValueDriversGrid
            dataSrc={gridData}
            mode={mode}
            format={format}
            chartHidden={chartHidden}
          />
        </>
      )}
    </div>
  );
};

export default CommentAnchor(memo(ValueDriver), {
  shouldScrollInToView: (anchorRecord, anchorId) =>
    anchorRecord?.moduleName === anchorId,
  getAnchorIdFromProp(props) {
    return props.currentSubmoduleName;
  },
});
